/**
 * Interaction Store - Signals for halo interaction system
 *
 * This store bridges the game engine's halo system with the Preact UI.
 * When the player enters an interaction zone, the halo provider updates
 * these signals, and the UI reacts to show prompts.
 */

import { signal } from '@preact/signals'

// ========================================
// Types
// ========================================

export interface ActiveInteraction {
  /** UI prompt label (e.g., "Press Enter to Start Character Builder") */
  label: string
  /** Callback to trigger when Enter is pressed */
  onInteract: () => void
}

// ========================================
// Signals
// ========================================

/**
 * Currently active interaction (closest halo within range)
 * null when player is not near any interactive object
 */
export const activeInteraction = signal<ActiveInteraction | null>(null)
